import React from "react";
import { TextArea } from "@campgladiator/cgui-core.atoms.textarea";
import { FormPart } from "@campgladiator/cgui-core.molecules.form-part";
import styles from "./MessageInput.module.scss";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";

export type MessageInputProps = {
  disabled?: boolean;
  handleCancelNote?: () => void;
  handleInputChange: (value: string) => void;
  id: string;
  initialInputValue?: string;
  isIconVisible?: boolean;
  name: string;
  placeHolder: string;
  value: string;
};

const MessageInput = ({
  disabled,
  id,
  isIconVisible,
  name,
  placeHolder,
  value,
  handleCancelNote,
  handleInputChange,
}: MessageInputProps) => (
  <div className={styles.messageInputContainer}>
    <FormPart forId={id} className={styles.form}>
      <TextArea
        id={id}
        name={name}
        value={value}
        onTextAreaChange={handleInputChange}
        placeholder={placeHolder}
        disabled={disabled}
        className={styles.textArea}
      />
      {isIconVisible && (
        <Icon.Line
          className={styles.icon}
          name="icon-times-circle"
          onClick={handleCancelNote}
        />
      )}
    </FormPart>
  </div>
);
export default MessageInput;
